<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Tables</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <div class="app-filter-good-table-container">
                    <vue-good-table
                        ref="listCustomerTable"
                        mode="remote"
                        title="Customers"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :selectOptions="{
                        }"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: 25,
                        setCurrentPage: serverParams.setCurrentPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"

                        :search-options="{
                        enabled: false,
                        }">
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'" >
                                    <!--class="btn btn-xs btn-primary"-->
                                    <router-link class="btn edit-btn-vvg waves-effect" title='View customer details' v-bind:to="{name: 'CustomerView',params:{id:props.row.id}}"><i class="fa fa-eye"></i></router-link>
                                </div>
                                <div v-else-if="props.column.field == 'customer_type'" >
                                    <template v-if="props.row.customer_type == 'Excede'">
                                        <h5><span class="badge badge-success bg-color-a6c888">{{props.row.customer_type}}</span></h5>
                                    </template>
                                    <template v-else>
                                        <h5><span class="badge badge-warning bg-color-fbd28b">{{props.row.customer_type}}</span></h5>
                                    </template>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button v-on:click="sendMail" title='Mail' >Mail</button>
                        </div>
                    </vue-good-table>
                </div>


                <div class="app-checkbox-good-table-container">
                    <div class="col-6 paddingleft0">
                        <vue-good-table
                            ref="smallTable1"
                            mode="remote"
                            title="Customers"
                            @on-selected-rows-change="selectionChanged"
                            @on-page-change="onPageChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            :totalRows="totalRecords"
                            :columns="columns1"
                            :rows="rows1"
                            :select-options="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            }"
                            :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams1.perPage,
                            setCurrentPage: serverParams1.setCurrentPage,
                            perPageDropdown: [5, 25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                            }"

                            :search-options="{
                            enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'" >
                                        <!--class="btn btn-xs btn-primary"-->
                                        <router-link class="btn edit-btn-vvg waves-effect" title='View customer details' v-bind:to="{name: 'CustomerView',params:{id:props.row.id}}"><i class="fa fa-eye"></i></router-link>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions" slot-scope="computed">
                                {{computed.selectedRows}}
                                <button v-on:click="loadCustomers" title='Mail' >Mail</button>
                            </div>
                        </vue-good-table>
                    </div>
                </div>


            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';
    import VueGoodTable from 'vue-good-table';
    Vue.use(VueGoodTable);
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                columns: [
                    {
                        label: 'Collector',
                        field: 'user_first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Collector", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Number',
                        field: 'contact_phone',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact Number", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Email',
                        field: 'contact_email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },

                    {
                        label: 'Customer Type',
                        field: 'customer_type',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Type", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Excede', 'Arcadium'], // dropdown (with selected values) instead of text input
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created Date',
                        field: 'excede_created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Updated Date',
                        field: 'excede_updated_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rows: [],
                totalRecords: 42306,
                serverParams: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'cusid',
                        type: 'asc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                },
                columns1: [
                    {
                        label: 'Collector',
                        field: 'user_first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Collector", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Subject',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Due date',
                        field: 'excede_created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Updated Date',
                        field: 'excede_updated_at',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rows1: [],
                totalRecords1: 42306,
                serverParams1: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'cusid',
                        type: 'asc',
                    },
                    page: 1,
                    perPage: 5,
                    setCurrentPage: 1,
                },
            }

        },
        beforeMount: function () {

        },
        mounted: function () {
            var self = this;
            self.loadCustomers();
        },
        methods: {
            loadCustomers: function () {
                var self = this;
                self.totalRecords = self.totalRecords1 = 42306;
                self.rows = [{
                        "id": 8524,
                        "first_name": "Macs Lift Gate Inc",
                        "contact_name": "",
                        "user_first_name": "Adriana Vargas",
                        "cusid": 100000,
                        "customer_type": "Excede",
                        "reg_age_days": 5418,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "562-634-5962",
                        "excede_created_at": "02/01/2004",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/02/2017",
                        "invoice_age": 396,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 396,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 1,
                        "first_name": "Alameda Auto Lab",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100001,
                        "customer_type": "Arcadium",
                        "reg_age_days": 817,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "09/06/2016",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "07/19/2018",
                        "invoice_age": 137,
                        "invoice_amount": "$26.80",
                        "paid_amount": "$332.56",
                        "current_due": "$0.00",
                        "due_days": 107,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 2,
                        "first_name": "Brubaker-mann Inc",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100002,
                        "customer_type": "Excede",
                        "reg_age_days": 1165,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "09/24/2015",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/27/2018",
                        "invoice_age": 6,
                        "invoice_amount": "$1,048.13",
                        "paid_amount": "$3,441.03",
                        "current_due": "$1,048.13",
                        "due_days": -24,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$1,048.13",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8525,
                        "first_name": "B K Auto Repair Shop",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100003,
                        "customer_type": "Excede",
                        "reg_age_days": 1092,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "12/06/2015",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "10/17/2018",
                        "invoice_age": 47,
                        "invoice_amount": "$653.88",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 47,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 3,
                        "first_name": "Bustos Trucking",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100004,
                        "customer_type": "Excede",
                        "reg_age_days": 396,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "714-964-9844",
                        "excede_created_at": "11/01/2017",
                        "excede_updated_at": "05/18/2018",
                        "invoice_date": "11/16/2018",
                        "invoice_age": 17,
                        "invoice_amount": "$-118.26",
                        "paid_amount": "$65.98",
                        "current_due": "$0.00",
                        "due_days": -13,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 5,
                        "first_name": "Bz Equipment Services Inc #########",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100006,
                        "customer_type": "Arcadium",
                        "reg_age_days": 3548,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "bzequipmentservices@yahoo.com",
                        "contact_phone": "909-356-4011",
                        "excede_created_at": "03/16/2009",
                        "excede_updated_at": "02/26/2018",
                        "invoice_date": "10/26/2018",
                        "invoice_age": 38,
                        "invoice_amount": "$167.86",
                        "paid_amount": "$341.83",
                        "current_due": "$0.00",
                        "due_days": 8,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$34.36",
                        "D61TO90D": "$120.85",
                        "total_due": "$155.21",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 6,
                        "first_name": "Calmet Services",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100007,
                        "customer_type": "Excede",
                        "reg_age_days": 4228,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "562-259-1239",
                        "excede_created_at": "05/06/2007",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "10/26/2018",
                        "invoice_age": 38,
                        "invoice_amount": "$924.00",
                        "paid_amount": "$145.55",
                        "current_due": "$0.00",
                        "due_days": -52,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8526,
                        "first_name": "California Collision Center",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100008,
                        "customer_type": "Excede",
                        "reg_age_days": 755,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "11/07/2016",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "12/13/2017",
                        "invoice_age": 355,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 355,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8527,
                        "first_name": "Byron T Trucking",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100009,
                        "customer_type": "Excede",
                        "reg_age_days": 721,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "12/11/2016",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "08/01/2018",
                        "invoice_age": 124,
                        "invoice_amount": "$6.19",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 124,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 7,
                        "first_name": "Cablecom",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100010,
                        "customer_type": "Excede",
                        "reg_age_days": 2314,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "714-666-2400",
                        "excede_created_at": "08/01/2012",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "10/09/2018",
                        "invoice_age": 55,
                        "invoice_amount": "$1,136.29",
                        "paid_amount": "$1,136.29",
                        "current_due": "$0.00",
                        "due_days": 25,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8528,
                        "first_name": "C Hernandez Transport",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100011,
                        "customer_type": "Excede",
                        "reg_age_days": 1582,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "626-712-3424",
                        "excede_created_at": "08/03/2014",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "09/22/2018",
                        "invoice_age": 72,
                        "invoice_amount": "$323.00",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 72,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8529,
                        "first_name": "West Coast Enterprises",
                        "contact_name": "",
                        "user_first_name": "Janet Lloyd",
                        "cusid": 100012,
                        "customer_type": "Arcadium",
                        "reg_age_days": 5416,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "562-948-2439",
                        "excede_created_at": "02/03/2004",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/02/2017",
                        "invoice_age": 396,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 396,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8530,
                        "first_name": "Ca Trucking",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100013,
                        "customer_type": "Excede",
                        "reg_age_days": 1904,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "951-640-4315",
                        "excede_created_at": "09/15/2013",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "09/24/2018",
                        "invoice_age": 70,
                        "invoice_amount": "$219.57",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 70,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8531,
                        "first_name": "1",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100015,
                        "customer_type": "Excede",
                        "reg_age_days": 2751,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "05/22/2011",
                        "excede_updated_at": "11/05/2017",
                        "invoice_date": "11/02/2017",
                        "invoice_age": 396,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 396,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8532,
                        "first_name": "Kbs Diesel & Fleet Service",
                        "contact_name": "",
                        "user_first_name": "Adriana Vargas",
                        "cusid": 100016,
                        "customer_type": "Excede",
                        "reg_age_days": 5417,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "714-540-4963",
                        "excede_created_at": "02/02/2004",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/20/2018",
                        "invoice_age": 13,
                        "invoice_amount": "$37.89",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 13,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 9,
                        "first_name": "Cal Coast Machinery Inc",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100017,
                        "customer_type": "Excede",
                        "reg_age_days": 1559,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "805-981-2866",
                        "excede_created_at": "08/26/2014",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/02/2017",
                        "invoice_age": 396,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$350.00",
                        "current_due": "$0.00",
                        "due_days": 366,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8500,
                        "first_name": "Alameda County Public Works Attn: Fiscal Dept",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100018,
                        "customer_type": "Excede",
                        "reg_age_days": 4553,
                        "created_at": "2018-09-19 08:00:06",
                        "contact_email": "",
                        "contact_phone": "925-803-7000",
                        "excede_created_at": "06/15/2006",
                        "excede_updated_at": "09/18/2018",
                        "invoice_date": "11/02/2017",
                        "invoice_age": 396,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$414.46",
                        "current_due": "$0.00",
                        "due_days": 366,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8533,
                        "first_name": "Cabreras Truck & Trailer Repair",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100019,
                        "customer_type": "Excede",
                        "reg_age_days": 3798,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "909-574-9037",
                        "excede_created_at": "07/09/2008",
                        "excede_updated_at": "08/23/2018",
                        "invoice_date": "12/01/2018",
                        "invoice_age": 2,
                        "invoice_amount": "$107.36",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 2,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 10,
                        "first_name": "C&a Transportation #",
                        "contact_name": "#########",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100020,
                        "customer_type": "Arcadium",
                        "reg_age_days": 3961,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "619-661-8330",
                        "excede_created_at": "01/28/2008",
                        "excede_updated_at": "08/22/2018",
                        "invoice_date": "12/01/2018",
                        "invoice_age": 2,
                        "invoice_amount": "$-303.49",
                        "paid_amount": "$2,165.05",
                        "current_due": "$3,998.31",
                        "due_days": -28,
                        "D1TO30D": "$1,901.80",
                        "D31TO60D": "$29.82",
                        "D61TO90D": "$0.00",
                        "total_due": "$3,764.88",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8534,
                        "first_name": "C Perez Mobile Repair",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100022,
                        "customer_type": "Excede",
                        "reg_age_days": 2889,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "909-376-8183",
                        "excede_created_at": "01/04/2011",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/23/2018",
                        "invoice_age": 10,
                        "invoice_amount": "$447.67",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 10,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8535,
                        "first_name": "Bruce Caballero",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100023,
                        "customer_type": "Excede",
                        "reg_age_days": 396,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "909-983-6033",
                        "excede_created_at": "11/01/2017",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "03/31/2018",
                        "invoice_age": 247,
                        "invoice_amount": "$156.52",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 247,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 12,
                        "first_name": "Burrtec Waste Industries",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100024,
                        "customer_type": "Excede",
                        "reg_age_days": 3380,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "951-241-5693",
                        "excede_created_at": "08/31/2009",
                        "excede_updated_at": "06/11/2018",
                        "invoice_date": "11/07/2018",
                        "invoice_age": 26,
                        "invoice_amount": "$104.09",
                        "paid_amount": "$654.52",
                        "current_due": "$104.09",
                        "due_days": -64,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$-694.08",
                        "total_due": "$-589.99",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8536,
                        "first_name": "Caar Transport",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100025,
                        "customer_type": "Excede",
                        "reg_age_days": 469,
                        "created_at": "2018-09-24 07:17:44",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "08/20/2017",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/30/2018",
                        "invoice_age": 3,
                        "invoice_amount": "$1,007.60",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 3,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8537,
                        "first_name": "Cal Pac Drilling",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100026,
                        "customer_type": "Excede",
                        "reg_age_days": 1684,
                        "created_at": "2018-09-24 07:17:44",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "04/23/2014",
                        "excede_updated_at": "07/18/2018",
                        "invoice_date": "04/09/2018",
                        "invoice_age": 238,
                        "invoice_amount": "$349.57",
                        "paid_amount": "$676.97",
                        "current_due": "$0.00",
                        "due_days": 238,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 13,
                        "first_name": "Caltrans/los Angeles Attn: Doe",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100027,
                        "customer_type": "Excede",
                        "reg_age_days": 1859,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "213-897-0831",
                        "excede_created_at": "10/30/2013",
                        "excede_updated_at": "09/19/2018",
                        "invoice_date": "11/28/2018",
                        "invoice_age": 5,
                        "invoice_amount": "$219.73",
                        "paid_amount": "$99.36",
                        "current_due": "$219.73",
                        "due_days": -25,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$219.73",
                        "amount_balance": "$2,546.01"
                    }];
                self.rows1 = [{
                        "id": 8524,
                        "first_name": "Macs Lift Gate Inc",
                        "contact_name": "",
                        "user_first_name": "Adriana Vargas",
                        "cusid": 100000,
                        "customer_type": "Excede",
                        "reg_age_days": 5418,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "562-634-5962",
                        "excede_created_at": "02/01/2004",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/02/2017",
                        "invoice_age": 396,
                        "invoice_amount": "$0.00",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 396,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 1,
                        "first_name": "Alameda Auto Lab",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100001,
                        "customer_type": "Excede",
                        "reg_age_days": 817,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "09/06/2016",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "07/19/2018",
                        "invoice_age": 137,
                        "invoice_amount": "$26.80",
                        "paid_amount": "$332.56",
                        "current_due": "$0.00",
                        "due_days": 107,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 2,
                        "first_name": "Brubaker-mann Inc",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100002,
                        "customer_type": "Excede",
                        "reg_age_days": 1165,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "09/24/2015",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "11/27/2018",
                        "invoice_age": 6,
                        "invoice_amount": "$1,048.13",
                        "paid_amount": "$3,441.03",
                        "current_due": "$1,048.13",
                        "due_days": -24,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$1,048.13",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 8525,
                        "first_name": "B K Auto Repair Shop",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100003,
                        "customer_type": "Excede",
                        "reg_age_days": 1092,
                        "created_at": "2018-09-24 07:17:43",
                        "contact_email": "",
                        "contact_phone": "",
                        "excede_created_at": "12/06/2015",
                        "excede_updated_at": "11/01/2017",
                        "invoice_date": "10/17/2018",
                        "invoice_age": 47,
                        "invoice_amount": "$653.88",
                        "paid_amount": "$0.00",
                        "current_due": "$0.00",
                        "due_days": 47,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    },
                    {
                        "id": 3,
                        "first_name": "Bustos Trucking",
                        "contact_name": "",
                        "user_first_name": "Jerome Concepcion",
                        "cusid": 100004,
                        "customer_type": "Excede",
                        "reg_age_days": 396,
                        "created_at": "2018-09-16 16:00:06",
                        "contact_email": "",
                        "contact_phone": "714-964-9844",
                        "excede_created_at": "11/01/2017",
                        "excede_updated_at": "05/18/2018",
                        "invoice_date": "11/16/2018",
                        "invoice_age": 17,
                        "invoice_amount": "$-118.26",
                        "paid_amount": "$65.98",
                        "current_due": "$0.00",
                        "due_days": -13,
                        "D1TO30D": "$0.00",
                        "D31TO60D": "$0.00",
                        "D61TO90D": "$0.00",
                        "total_due": "$0.00",
                        "amount_balance": "$0.00"
                    }];
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadCustomers();
            },
            updateParams(newProps) {

                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadCustomers();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field: ('first_name');
                    field: ('contact_name');
                    field: ('contact_phone');
                    field: ('contact_email');
                    field: ('description');
                    field: ('cusid');
                    field:('customer_type');
                    field:('description');
                    field:('created_at');
                }
                ;
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.first_name || filters.contact_name || filters.contact_phone || filters.contact_email
                        || filters.user_first_name || filters.cusid || filters.created_at || filters.customer_type
                        || filters.description) {
                    this.loadCustomers();
                }

            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    },
                });
                this.loadCustomers();
            },
            onRowClick(params) {
                var id = params.row.id;
                var self = this;
                self.$router.push({path: `/customer/view/${id}`});
            },
            selectionChanged() {
                var self = this;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/tables.vue